module.exports = __webpack_public_path__ + "static/img/鼓励员工大会@2x.fa07c27.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/鼓励员工大会@2x.png
// module id = xEgo
// module chunks = 0